import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	refreshApp: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	refreshApp: {
		id: 'forge-ui-renderers.common.error-panel.refresh-app',
		defaultMessage: 'Refresh app',
		description: 'This text is displayed on a button that lets the user refresh a Forge app.',
	},
});
export default messages;
